import type { FC, PropsWithChildren } from "react";

import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { ClickableCellWrapper } from "app/pages/sales-intelligence/common-components/table-cells";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { useLeadCellActions } from "app/pages/sales-intelligence/modules/leads-search/hooks/cells/useLeadCellActions";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

interface ISignalCellRightBarLogicProps {
    row: LeadsSearchRow;
}

export const SignalCellRightBarLogicContainer: FC<PropsWithChildren<ISignalCellRightBarLogicProps>> = ({
    row,
    children,
}) => {
    const { onToggleSidebar: handleToggleRightSidebar } = useLeadCellActions({
        record: row,
        widgetId: "signals",
        onToggleRightSidebar: () => trackingService.columns.trackSignalsSidebarOpen(),
    });

    return (
        <Tooltip
            content={translate("si.signals.table-columns.any.tooltip")}
            enabled
            placement="top"
        >
            <ClickableCellWrapper
                onClick={handleToggleRightSidebar}
                centered
            >
                {children}
            </ClickableCellWrapper>
        </Tooltip>
    );
};
